import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    gerarArray,
} from '../../../business-components/Array/Array'

import {
    ano,
    mes,
    mesMesAno,
    anoMesAno,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import {
    despesaDetutivelAnualLimite,
    percDespesaDetutivelRendaTributavel,
    percPGBL,
    tabelaIR,
} from '../../../business-rules/List/impostoRenda'

import {
    calculaIndexGraficoAnosIdades,
    calculaJaAposentou,
    calculaAnosDepoisAposentar,
    calculaMesesDepoisAposentar,
    calculaGraficoAcumulacaoMensal,
} from '../estudo-form/EstudoServiceCalculo'

import {
    calculaTaxaRetornoLiquida,
    converteTaxaAnualEmMensal,
} from '../estudo-form/EstudoServiceMatematicaFinanceira'

import {
    calculaEconomiaInventario
} from '../estudo-form/EstudoServiceSucessaoVitalicia'



const calculaDespesaDetutivelRendaTributavelAnual = (values) => {

    return round(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2) * percDespesaDetutivelRendaTributavel / 100, 2)
}

const calculaIR = (baseCalculo) => {

    let ir = 0

    let ind = 0

    while (ind <= tabelaIR.length - 1) {

        if (baseCalculo <= tabelaIR[ind].baseCalculoAte || !tabelaIR[ind].baseCalculoAte) {

            ir = round((baseCalculo * tabelaIR[ind].aliquota / 100) - tabelaIR[ind].parcelaDeduzir, 2)

            break
        }

        ind++
    }

    return ir
}

export const calculaVGBLouPGBLVGBL = (values) => {

    let VGBLouPGBLVGBL
    let despesaDetutivelRendaTributavelAnual
    let despesaDetutivelAnualPrevidenciaPrivada
    let despesaDetutivelAnualPrevidenciaPrivadaCalc
    let despesaDetutivelAnualComPrevidenciaPrivada
    let despesaDetutivelMensalPrevidenciaPrivada
    let despesaDetutivelMensalPrevidenciaPrivadaCalc
    let percPGBLCalc
    let baseCalculoIrRendaTributavelAnual
    let irRendaTributavelAnual
    let baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada
    let irRendaTributavelAnualComPrevidenciaPrivada

    if (values.objPrevidenciaPrivada.rendaTributavelAnual && values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada) {

        despesaDetutivelRendaTributavelAnual = calculaDespesaDetutivelRendaTributavelAnual(values)

        despesaDetutivelAnualPrevidenciaPrivada = round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2) * percPGBL / 100

        despesaDetutivelMensalPrevidenciaPrivada = round(despesaDetutivelAnualPrevidenciaPrivada / 12, 2)

        if (
                values.objPrevidenciaPrivada.simularAportePGBLInferiorMaximoPossivel &&
                (
                    (
                        values.objPrevidenciaPrivada.aporteAnualPGBL &&
                        values.objPrevidenciaPrivada.aporteAnualPGBL <= despesaDetutivelAnualPrevidenciaPrivada
                    ) ||
                    (
                        values.objPrevidenciaPrivada.aporteMensalPGBL &&
                        values.objPrevidenciaPrivada.aporteMensalPGBL <= despesaDetutivelMensalPrevidenciaPrivada
                    )
                )
        ) {

            if (values.objPrevidenciaPrivada.aporteAnualPGBL) {

                despesaDetutivelAnualPrevidenciaPrivadaCalc =
                    round(values.objPrevidenciaPrivada.aporteAnualPGBL, 2)
                despesaDetutivelMensalPrevidenciaPrivadaCalc =
                    round(values.objPrevidenciaPrivada.aporteAnualPGBL / 12, 2)

            } else {

                despesaDetutivelAnualPrevidenciaPrivadaCalc =
                    round(values.objPrevidenciaPrivada.aporteMensalPGBL * 12, 2)
                despesaDetutivelMensalPrevidenciaPrivadaCalc =
                    round(values.objPrevidenciaPrivada.aporteMensalPGBL, 2)
            }

            percPGBLCalc = round(despesaDetutivelAnualPrevidenciaPrivadaCalc /
                values.objPrevidenciaPrivada.rendaTributavelAnual * 100, 2)

        } else {

            despesaDetutivelAnualPrevidenciaPrivadaCalc = despesaDetutivelAnualPrevidenciaPrivada
            despesaDetutivelMensalPrevidenciaPrivadaCalc = despesaDetutivelMensalPrevidenciaPrivada

            percPGBLCalc = percPGBL
        }

        despesaDetutivelAnualComPrevidenciaPrivada = round(
            round(values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada, 2) +
                despesaDetutivelAnualPrevidenciaPrivadaCalc, 2)
                
        if (
                despesaDetutivelAnualComPrevidenciaPrivada <= despesaDetutivelRendaTributavelAnual &&
                despesaDetutivelAnualComPrevidenciaPrivada <= despesaDetutivelAnualLimite
        ) {

            VGBLouPGBLVGBL = HARDCODE.VGBLDeclaracaoSimplificada

        } else {

            VGBLouPGBLVGBL = HARDCODE.PGBLVGBLDeclaracaoCompleta
        }

        if (VGBLouPGBLVGBL === HARDCODE.PGBLVGBLDeclaracaoCompleta) {
            
            baseCalculoIrRendaTributavelAnual = round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2) -
                round(values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada, 2)

            irRendaTributavelAnual = calculaIR(baseCalculoIrRendaTributavelAnual)

            baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada = baseCalculoIrRendaTributavelAnual -
                despesaDetutivelAnualPrevidenciaPrivadaCalc

            irRendaTributavelAnualComPrevidenciaPrivada = calculaIR(baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada)
        
            if (irRendaTributavelAnualComPrevidenciaPrivada === 0 && irRendaTributavelAnual > 0) {

                while (irRendaTributavelAnualComPrevidenciaPrivada === 0) {

                    despesaDetutivelAnualPrevidenciaPrivadaCalc -= 1

                    baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada = baseCalculoIrRendaTributavelAnual -
                        despesaDetutivelAnualPrevidenciaPrivadaCalc

                    irRendaTributavelAnualComPrevidenciaPrivada = calculaIR(baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada)
                }

                despesaDetutivelAnualPrevidenciaPrivadaCalc += 1

                baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada = baseCalculoIrRendaTributavelAnual -
                    despesaDetutivelAnualPrevidenciaPrivadaCalc

                irRendaTributavelAnualComPrevidenciaPrivada = calculaIR(baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada)

                despesaDetutivelMensalPrevidenciaPrivadaCalc = round(despesaDetutivelAnualPrevidenciaPrivadaCalc / 12, 2)
            }
        }
    }

    return { VGBLouPGBLVGBL, percDespesaDetutivelRendaTributavel, despesaDetutivelRendaTributavelAnual,
        percPGBL, percPGBLCalc,
            despesaDetutivelAnualPrevidenciaPrivada, despesaDetutivelAnualPrevidenciaPrivadaCalc,
                despesaDetutivelMensalPrevidenciaPrivada, despesaDetutivelMensalPrevidenciaPrivadaCalc,
                    despesaDetutivelAnualComPrevidenciaPrivada, despesaDetutivelAnualLimite,
                        baseCalculoIrRendaTributavelAnual, irRendaTributavelAnual,
                            baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada,
                                irRendaTributavelAnualComPrevidenciaPrivada }
}

export const calculaGraficoPrevidenciaPrivada = (values, estudo, simulacao, aporte, calcularEconomiaInventario) => {

    const anoAtual = ano(values.dataSimulacaoEstudo)
    const mesAtual = mes(values.dataSimulacaoEstudo)

    let mesFinalSimulacao = 0
    let anoFinalSimulacao = 0

    if (simulacao.projetoVidaSonho) {

        aporte?.forEach( (linhaAporte, indAporte) => {

            const mesFinal = mesMesAno(linhaAporte.mesAnoFinalAporte)
            const anoFinal = anoMesAno(linhaAporte.mesAnoFinalAporte)

            if (anoFinal > anoFinalSimulacao || (anoFinal === anoFinalSimulacao && mesFinal > mesFinalSimulacao)) {

                mesFinalSimulacao = mesFinal
                anoFinalSimulacao = anoFinal
            }
        })
    }

    if (anoFinalSimulacao === 0) {

        mesFinalSimulacao = 12
        anoFinalSimulacao = values.anoFinalVitalicioClienteConjuge
    }

    const indexGraficoAnos = calculaIndexGraficoAnosIdades(estudo.current.graficoAnos, anoFinalSimulacao)

    const indexTotalAcumulado =
        simulacao.projetoVidaSonho
            ?
                indexGraficoAnos
            :
                calculaIndexGraficoAnosIdades(estudo.current.graficoAnos, values.anoFinalVaiAposentarCliente)

    const graficoSimulacao = gerarArray(0, indexGraficoAnos + 1)

    const graficoPrevidenciaPrivada = [...graficoSimulacao]
    const graficoPrevidenciaPrivadaAporte = [...graficoSimulacao]

    let totalPrevidenciaPrivadaCalculoMediaPonderadaTaxa = 0
    let totalPrevidenciaPrivadaVezesTaxaCalculoMediaPonderadaTaxa = 0
    
    aporte?.forEach( (linhaAporte, indAporte) => {

        if (linhaAporte.tipoPeriodicidadeAporte === HARDCODE.idTipoPeriodicidadeUnica) {

            linhaAporte.mesAnoFinalAporte = linhaAporte.mesAnoInicialAporte
        }

        let taxaRetornoAnualReal = values.taxaRetornoAnualReal
        let taxaRetornoAnualRealAposAposentadoria = values.taxaRetornoAnualRealAposAposentadoria
      
        let taxaJurosAnual
        let tipoMomentoTributacaoIR
        let percIR
        let tempoMinimoEntreAportesResgatesCalculoIRAnos

        if (linhaAporte.taxaJurosAnual || linhaAporte.taxaJurosAnual === 0 || linhaAporte.tipoMomentoTributacaoIR) {

            taxaJurosAnual = 
                linhaAporte.taxaJurosAnual || linhaAporte.taxaJurosAnual === 0
                    ?
                        linhaAporte.taxaJurosAnual
                    :
                        simulacao.taxaJurosAnual || simulacao.taxaJurosAnual === 0
                            ?
                                simulacao.taxaJurosAnual
                            :
                                values.taxaJurosAnual

            if (linhaAporte.tipoMomentoTributacaoIR) {

                tipoMomentoTributacaoIR = linhaAporte.tipoMomentoTributacaoIR
                percIR = linhaAporte.percIR
                tempoMinimoEntreAportesResgatesCalculoIRAnos = linhaAporte.tempoMinimoEntreAportesResgatesCalculoIRAnos

            } else {

                if (simulacao.tipoMomentoTributacaoIR) {

                    tipoMomentoTributacaoIR = simulacao.tipoMomentoTributacaoIR
                    percIR = simulacao.percIR
                    tempoMinimoEntreAportesResgatesCalculoIRAnos = simulacao.tempoMinimoEntreAportesResgatesCalculoIRAnos
                    
                } else {

                    tipoMomentoTributacaoIR = values.tipoMomentoTributacaoIR
                    percIR = values.percIR
                    tempoMinimoEntreAportesResgatesCalculoIRAnos = values.tempoMinimoEntreAportesResgatesCalculoIRAnos
                }
            }

        } else {

            if (simulacao.taxaJurosAnual || simulacao.taxaJurosAnual === 0 || simulacao.tipoMomentoTributacaoIR) {

                taxaJurosAnual =
                    simulacao.taxaJurosAnual || simulacao.taxaJurosAnual === 0
                        ?
                            simulacao.taxaJurosAnual
                        :
                            values.taxaJurosAnual
                            
                if (simulacao.tipoMomentoTributacaoIR) {

                    tipoMomentoTributacaoIR = simulacao.tipoMomentoTributacaoIR
                    percIR = simulacao.percIR
                    tempoMinimoEntreAportesResgatesCalculoIRAnos = simulacao.tempoMinimoEntreAportesResgatesCalculoIRAnos
                    
                } else {

                    tipoMomentoTributacaoIR = values.tipoMomentoTributacaoIR
                    percIR = values.percIR
                    tempoMinimoEntreAportesResgatesCalculoIRAnos = values.tempoMinimoEntreAportesResgatesCalculoIRAnos
                }
            }
        }

        if (taxaJurosAnual || tipoMomentoTributacaoIR) {

            taxaRetornoAnualReal = calculaTaxaRetornoLiquida(taxaJurosAnual, values.taxaInflacaoAnual, tipoMomentoTributacaoIR,
                percIR, tempoMinimoEntreAportesResgatesCalculoIRAnos)

            taxaRetornoAnualRealAposAposentadoria = taxaRetornoAnualReal
        }

        const mesInicial = mesMesAno(linhaAporte.mesAnoInicialAporte)
        const anoInicial = anoMesAno(linhaAporte.mesAnoInicialAporte)
        const mesFinal = mesMesAno(linhaAporte.mesAnoFinalAporte)
        const anoFinal = anoMesAno(linhaAporte.mesAnoFinalAporte)

        let valorAporte = round(linhaAporte.valorAporte, 2)

        if (!tipoMomentoTributacaoIR) {

            tipoMomentoTributacaoIR = values.tipoMomentoTributacaoIR
            percIR = values.percIR
        }

        if (tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRPGBL && percIR) {

            valorAporte = round(valorAporte - (valorAporte * percIR / 100), 2)
        }
    
        let saldo = calculaGraficoAcumulacaoMensal(mesInicial, anoInicial, mesFinal, anoFinal, 0, valorAporte,
            linhaAporte.tipoPeriodicidadeAporte, estudo.current.graficoAnos, graficoPrevidenciaPrivada, null,
                values, estudo, taxaRetornoAnualReal, taxaRetornoAnualRealAposAposentadoria,
                    true, null, null, null, null, null)

        if (mesFinal < 12) {

            const indexGraficoAnos =
                calculaIndexGraficoAnosIdades(estudo.current.graficoAnos, anoFinal)

            graficoPrevidenciaPrivada[indexGraficoAnos] -= saldo
        }

        const mesInicialSaldo = mesFinal === 12 ? 1 : mesFinal + 1
        const anoInicialSaldo = mesFinal === 12 ? anoFinal + 1 : anoFinal

        saldo = calculaGraficoAcumulacaoMensal(mesInicialSaldo, anoInicialSaldo, mesFinalSimulacao,
            anoFinalSimulacao, saldo, 0, linhaAporte.tipoPeriodicidadeAporte,
                estudo.current.graficoAnos, graficoPrevidenciaPrivada, null,
                    values, estudo, taxaRetornoAnualReal, taxaRetornoAnualRealAposAposentadoria,
                        true, null, null, null, null, null)

        totalPrevidenciaPrivadaCalculoMediaPonderadaTaxa += saldo
        totalPrevidenciaPrivadaVezesTaxaCalculoMediaPonderadaTaxa += (saldo * taxaRetornoAnualRealAposAposentadoria)
                    
                        
        saldo = calculaGraficoAcumulacaoMensal(mesInicial, anoInicial,
            mesFinal, anoFinal, 0, valorAporte,
                linhaAporte.tipoPeriodicidadeAporte, estudo.current.graficoAnos, graficoPrevidenciaPrivadaAporte, null,
                    values, estudo, 0, 0, true, null, null, null, null, null)

        if (mesFinal < 12) {

            const indexGraficoAnos =
                calculaIndexGraficoAnosIdades(estudo.current.graficoAnos, anoFinal)

            graficoPrevidenciaPrivadaAporte[indexGraficoAnos] -= saldo
        }

        //const mesInicialSaldo = mesFinal === 12 ? 1 : mesFinal + 1
        //const anoInicialSaldo = mesFinal === 12 ? anoFinal + 1 : anoFinal

        calculaGraficoAcumulacaoMensal(mesInicialSaldo, anoInicialSaldo, mesFinalSimulacao,
            anoFinalSimulacao, saldo, 0, linhaAporte.tipoPeriodicidadeAporte,
                estudo.current.graficoAnos, graficoPrevidenciaPrivadaAporte, null,
                    values, estudo, 0, 0, true, null, null, null, null, null)
    })



    const taxaRetornoAnualRealPonderada = round(totalPrevidenciaPrivadaVezesTaxaCalculoMediaPonderadaTaxa /
        totalPrevidenciaPrivadaCalculoMediaPonderadaTaxa, 2)
    const taxaRetornoAnualRealAposAposentadoriaPonderada = taxaRetornoAnualRealPonderada
    

    const graficoPrevidenciaPrivadaConsumirReservaAposentadoria = [...graficoPrevidenciaPrivada]
    const graficoPrevidenciaPrivadaPreservarReservaAposentadoria = [...graficoPrevidenciaPrivada]

    //const saldoInicioAposentadoria =
    //    graficoPrevidenciaPrivada[nvl(calculaIndexGraficoAnosIdades(estudo.current.graficoIdades,
    //        values.idadeVaiAposentarCliente), 0)]

    const fatorTaxaRetornoMensalRealAposAposentadoriaPonderada =
        converteTaxaAnualEmMensal(taxaRetornoAnualRealAposAposentadoriaPonderada) / 100

    const jaAposentou = calculaJaAposentou(values, anoAtual)

    const anosDepoisAposentar = calculaAnosDepoisAposentar(values, anoAtual, jaAposentou) 
    const mesesDepoisAposentar = calculaMesesDepoisAposentar(mesAtual, jaAposentou, anosDepoisAposentar)

    const saldoInicioAposentadoria =
        round(graficoPrevidenciaPrivada[graficoPrevidenciaPrivada.length - 1] /
            Math.pow(1 + fatorTaxaRetornoMensalRealAposAposentadoriaPonderada, mesesDepoisAposentar), 2)

    let valorRetiradaMensalMaximaConsumirReservaAposentadoria

    if (!simulacao.projetoVidaSonho) {

        if (taxaRetornoAnualRealAposAposentadoriaPonderada === 0) {
        
            valorRetiradaMensalMaximaConsumirReservaAposentadoria =
                round(saldoInicioAposentadoria / mesesDepoisAposentar, 2)
        
        } else {
            
            valorRetiradaMensalMaximaConsumirReservaAposentadoria =
                round((saldoInicioAposentadoria *
                    Math.pow(1 + fatorTaxaRetornoMensalRealAposAposentadoriaPonderada, mesesDepoisAposentar - 1) *
                        fatorTaxaRetornoMensalRealAposAposentadoriaPonderada) /
                            (Math.pow(1 + fatorTaxaRetornoMensalRealAposAposentadoriaPonderada, mesesDepoisAposentar) - 1), 2)
        }

        calculaGraficoAcumulacaoMensal(null, values.anoFinalVaiAposentarCliente + 1, mesFinalSimulacao, anoFinalSimulacao,
            0, valorRetiradaMensalMaximaConsumirReservaAposentadoria * -1, null, estudo.current.graficoAnos,
                graficoPrevidenciaPrivadaConsumirReservaAposentadoria,
                    null, values, estudo, taxaRetornoAnualRealPonderada,
                        taxaRetornoAnualRealAposAposentadoriaPonderada, true, null, null, null, null, null)
    }

    let valorRetiradaMensalMaximaPreservarReservaAposentadoria
    
    if (!simulacao.projetoVidaSonho) {

        valorRetiradaMensalMaximaPreservarReservaAposentadoria =
            round(saldoInicioAposentadoria - (saldoInicioAposentadoria / 
                (1 + fatorTaxaRetornoMensalRealAposAposentadoriaPonderada)), 2)

        calculaGraficoAcumulacaoMensal(null, values.anoFinalVaiAposentarCliente + 1, mesFinalSimulacao, anoFinalSimulacao,
            0, valorRetiradaMensalMaximaPreservarReservaAposentadoria * -1, null, estudo.current.graficoAnos,
                graficoPrevidenciaPrivadaPreservarReservaAposentadoria,
                    null, values, estudo, taxaRetornoAnualRealPonderada,
                        taxaRetornoAnualRealAposAposentadoriaPonderada, true, null, null, null, null, null)

        estudo.current.graficoAnos?.forEach( (linhaGraficoAnos, index) => {

            if (linhaGraficoAnos < values.anoFinalVaiAposentarCliente) {

                graficoPrevidenciaPrivadaConsumirReservaAposentadoria[index] = null
                graficoPrevidenciaPrivadaPreservarReservaAposentadoria[index] = null
            }
        })
    }



    const graficoPrevidenciaPrivadaRentabilidade = [...graficoSimulacao]

    graficoPrevidenciaPrivadaRentabilidade?.forEach( (linha, ind) => {

        graficoPrevidenciaPrivadaRentabilidade[ind] =
            graficoPrevidenciaPrivada[ind] - graficoPrevidenciaPrivadaAporte[ind]

        if (
                ind > 0 &&
                (
                    graficoPrevidenciaPrivadaAporte[ind - 1] === null ||
                    graficoPrevidenciaPrivadaAporte[ind] === graficoPrevidenciaPrivadaAporte[ind - 1]
                )
        ) { // Tratamento para o exibir somente até o fim dos aportes

            graficoPrevidenciaPrivadaAporte[ind] = null
        }
    })


    

    const valorEconomiaInventarioPrevidenciaPrivada =
        calcularEconomiaInventario
            ?
                calculaEconomiaInventario(values, graficoPrevidenciaPrivada[indexTotalAcumulado])
            :
                ''

    

    return { graficoPrevidenciaPrivada, graficoPrevidenciaPrivadaAporte, graficoPrevidenciaPrivadaRentabilidade,
        valorRetiradaMensalMaximaConsumirReservaAposentadoria, graficoPrevidenciaPrivadaConsumirReservaAposentadoria,
            valorRetiradaMensalMaximaPreservarReservaAposentadoria, graficoPrevidenciaPrivadaPreservarReservaAposentadoria,
                indexTotalAcumulado, valorEconomiaInventarioPrevidenciaPrivada
    }
}